import React from 'react';
import cn from 'classnames';

import PIC_QUICK_INACTIVE from '../../assets/images/salon-settings.svg';
import PIC_QUICK_ACTIVE from '../../assets/images/salon-settings-active.svg';
import PIC_CUSTOM_ACTIVE from '../../assets/images/scissors-active-Remade-JS.svg';
import PIC_CUSTOM_INACTIVE from '../../assets/images/scissors-Remade-JS.svg';
import { USE_CUSTOM_SETUP } from '../../config/use.conf';

const SALON_SETUP_TEXT = [
  'To get you started as quickly as possible, we’ll create an account for you with sample services, prices and staff.',
  'But don’t worry, you can edit these easily later!',
].join(' ');

const IMAGE_STYLE = Object.freeze({ width: 52, marginTop: -34 });

const SalonSetupType = ({ active, onCustomizedClick, onQuickSetupClick }) => (
  <div data-bem="SalonSetupType" className="content auto-height">
    <label htmlFor="salonTypeSelector">
      <div data-bem="SalonSetupType__option-1" className="row">
        <button
          className={cn({
            'section-button': true,
            'active-border': active === 1,
          })}
          onClick={onQuickSetupClick}
        >
          <img
            className="section-icon"
            src={active === 1 ? PIC_QUICK_ACTIVE : PIC_QUICK_INACTIVE}
            alt="ServicePriceImage"
            style={IMAGE_STYLE}
          />
          <div className="section-text-wrap">
            <div className="section-header-text">Quick Salon Setup</div>
            <div className="section-text">{SALON_SETUP_TEXT}</div>
          </div>
        </button>
      </div>
      {USE_CUSTOM_SETUP && (
        <div data-bem="SalonSetupType__option-2" id="salonTypeSelector">
          <div className="">
            <button
              className={cn({
                'section-button': true,
                'active-border': active === 2,
              })}
              onClick={onCustomizedClick}
            >
              <img
                className="section-icon"
                src={active === 2 ? PIC_CUSTOM_ACTIVE : PIC_CUSTOM_INACTIVE}
                alt="CustomizedImage"
                style={IMAGE_STYLE}
              />
              <div className="section-text-wrap">
                <div className="section-header-text">Customised Salon Setup</div>
                <div className="section-text">
                  Enter services and staff with customisable names, prices and category colours.
                </div>
              </div>
            </button>
          </div>
        </div>
      )}
    </label>
  </div>
);

export default SalonSetupType;
